import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {AbstractService} from '../abstract.service';
import {Mensagem} from '../../model/planilhas/mensagem.model';
import {PreenchFormModel} from '../../model/planilhas/preench-form.model';
import {ResponseDto} from '../../dto/response-dto';

@Injectable({providedIn: 'root'})
export class PreenchFechFormularioService extends AbstractService {

    private readonly URL_API_PLANILHAS = this.API_REST_PLANILHAS + '/preenchimentos';

    constructor(http: HttpClient) {
        super(http);
    }

    postConfirmaPreenchimento(preenchimento_campo_id: number): Observable<Mensagem> {
        return this.http.post<Mensagem>(`${this.URL_API_PLANILHAS}/confirma-pendente/`, {preenchimento_campo_id});
    }

    getPreenchimento(id: number): Observable<PreenchFormModel> {
        return this.http.get<PreenchFormModel>(`${this.URL_API_PLANILHAS}/todos/` + id);
    }

    getPreenchimentoTodosComFoto(id: number): Observable<PreenchFormModel[]> {
        return this.http.get<PreenchFormModel[]>(`${this.URL_API_PLANILHAS}/todos-com-fotos/form/` + id);
    }

    getPreenchimentosComFotosPC(preenchimento_campo_id: number): Observable<PreenchFormModel> {
        return this.http.get<PreenchFormModel>(`${this.URL_API_PLANILHAS}/todos-com-fotos/preench-campo/` + preenchimento_campo_id);
    }

    getCondicionaisByIdPreenchimentoCampo(idPreenchimentoCampo: number): Observable<PreenchFormModel[]> {
        return this.http.get<PreenchFormModel[]>(`${this.URL_API_PLANILHAS}/condicionais/by/id-preenchimento-campo/` + idPreenchimentoCampo);
    }

    postPreenchimentoComFoto(preenchimentosForm: PreenchFormModel[], fotos: File[], service?: string, objectGeneric?: any): Observable<Mensagem> {
        preenchimentosForm.forEach(n => {
            delete n._campo;
            delete n._campo_form_visivel_id;
            delete n._campo_form_visivel_nome;
            delete n._fase;
            delete n._imgbase64;
        })
        let formdata: FormData = new FormData();
        if (fotos.length > 0) {
            fotos.forEach(foto => {
                formdata.append('files', foto);
            });
        }
        formdata.append('preenchimentos', JSON.stringify(preenchimentosForm));
        return this.http.post<Mensagem>(`${this.URL_API_PLANILHAS}/adicionar-com-fotos`, formdata);
    }

    postEditPreenchimentoComFoto(preenchimentosForm: PreenchFormModel[], arquivos: File[]): Observable<ResponseDto> {
        preenchimentosForm.forEach(n => {
            delete n._campo;
            delete n._campo_form_visivel_id;
            delete n._campo_form_visivel_nome;
            delete n._fase;
            delete n._imgbase64;
        });
        const formdata: FormData = new FormData();
        if (arquivos.length > 0) {
            arquivos.forEach(foto => {
                formdata.append('files', foto);
            });
        }
        formdata.append('preenchimentos', JSON.stringify(preenchimentosForm));
        return this.http.post<ResponseDto<void>>(`${this.URL_API_PLANILHAS}/editar-com-fotos`, formdata);
    }

    gerarPDF(ids: any): Observable<any> {
        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
        };
        return this.http.get<any>(`${this.URL_API_PLANILHAS}/gerar-pdf/` + ids, httpOptions);
    }

    getPreenchimentosListId(idList: number[]): Observable<PreenchFormModel[]> {
        return this.http.get<PreenchFormModel[]>(`${this.URL_API_PLANILHAS}/find/by/list-id/` + idList.join());
    }

    getListIdPreenchimentosById(id: number): Observable<ResponseDto<number[]>> {
        return this.http.get<ResponseDto<number[]>>(`${this.URL_API_PLANILHAS}/find/list/id/preenchimentos/by/id/${id}`)
    }

    findImgByPathBase64(path: string): Observable<ResponseDto> {
        const filterMap = {
            path: path
        };
        return this.http.get<ResponseDto>(`${this.URL_API_PLANILHAS}/find/img/by/path`, {params: new HttpParams({fromObject: filterMap})});
    }

    postPreenchimentoGenerico(preenchimentoForm: PreenchFormModel[], fotos: File[]): Observable<Mensagem> {
        preenchimentoForm.forEach(n => {
            delete n._campo;
            delete n._campo_form_visivel_id;
            delete n._campo_form_visivel_nome;
            delete n._fase;
            delete n._imgbase64;
        });
        console.log(preenchimentoForm);
        let formdata: FormData = new FormData();
        if (fotos.length > 0) {
            fotos.forEach(foto => {
                formdata.append('files', foto);
            });
        }
        formdata.append('preenchimentos', JSON.stringify(preenchimentoForm));
        return this.http.post<Mensagem>(`${this.URL_API_PLANILHAS}/adicionar-com-fotos`, formdata);
    }

    findAllPreenchimentoByConectaPreenchimentos(uuid: string) {
        return this.http.get<ResponseDto<PreenchFormModel[]>>(`${this.URL_API_PLANILHAS}/find-all-preenchimentos-by-conecta-preenchimentos/${uuid}`);
    }

    findSignatureImage(preenchimentoCampoId: number, estruturaId: number): Observable<Blob> {
        return this.http.get(
            `${this.API_REST_PLANILHAS}/assinaturas/preenchimentos/` +
            `${preenchimentoCampoId}/campos/${estruturaId}/imagem`,
            {
                responseType: 'blob'
            }
        );
    }
}
